export const capitalize = (s: string) =>
  s.length > 0 ? `${s[0].toUpperCase()}${s.slice(1)}` : "";
